<template>
  <div class="">
    <h5>اشتراک گذاری</h5>
    <table class="table table-responsive-md table-striped">
      <thead>
      <tr>
        <th scope="col">شناسه</th>
        <th scope="col">نام</th>
        <th scope="col">ایتم</th>
        <th scope="col">محدودیت بازدید</th>
        <th scope="col">تعداد بازدید</th>
        <th scope="col">لینک</th>
        <th scope="col">تاریخ ساخت</th>
        <th scope="col">#</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="share in shares">
        <td>{{ share.id }}</td>
        <td>{{ share.name }}</td>
        <td>
          <m-a target="_blank" :href="manageItemName(share).link">
            {{ manageItemName(share).name }}
          </m-a>
        </td>
        <td>{{ share.visit_limit == null ? 'ندارد' : share.visit_limit }}</td>
        <td>{{ share.visit_count }}</td>
        <td class="text-center">
          <a :href="linkManager(share)" target="_blank">
            <b-icon icon="box-arrow-up-right" class="h5"/>
          </a>
        </td>
        <td dir="ltr">{{ dateConverter(share.created_at, '/', true) }}</td>
        <td class="text-center">
          <b-icon @click="deleteItem(share)" class="m-1 h5" icon="trash"/>
          <b-icon class="m-1 h5" v-b-modal="`share-edit-${share.id}`" icon="pencil-fill"/>

          <b-modal :id="`share-edit-${share.id}`" :ref="`form-update-${share.id}`" hide-footer>
            <div class="text-right" dir="rtl">
              <share-form :share="share" @updateItem="manageItemAfterUpdate" :item="share.shareable"
                          :shareable_type="share.shareable_type"
                          :shareable_id="share.shareable_id"/>
            </div>
          </b-modal>

        </td>
      </tr>
      </tbody>
    </table>

    <div class="row text-center pt-3">
      <div class="mt-3 ml-auto mr-auto color">
        <pagination :meta="pagination" :on-change-page="changePage"/>
      </div>
    </div>

  </div>
</template>


<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Pagination from "../../components/dashboard/Pagination.vue";
import ShareForm from "../../components/dashboard/Share/ShareForm.vue";
import $ from 'jquery'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Share",
  components: {ShareForm, Pagination},
  data() {
    return {
      $,
      pagination: {},
      shares: []
    }
  },
  methods: {
    dateConverter,
    getShares(page = 1) {
      this.$store.dispatch('Share/getShares', page).then(res => {
        let baseData = res.data.data
        this.pagination = baseData.meta
        this.shares = baseData.data
      })
    },
    manageItemName(share) {
      if (share.shareable_type == 'product') {
        let item  = share.shareable;
        let link = { name: 'EditProduct', params: { slug: item.raw_link } }
        return {name: item.name, link: link}
      }
      return ''
    },
    changePage(page) {
      this.getShares(page)
    },
    deleteItem(share) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.$store.dispatch('Share/deleteShare', share).then(res => {
          this.getShares()
        })
      }
    },
    manageItemAfterUpdate(item) {
      this.$refs[`form-update-${item.id}`][0].hide()
      this.getShares()
    },
    linkManager(item) {
      let routeData = {href: null};

      if (item.shareable_type == 'product') {
        routeData = this.$router.resolve({name: 'ProductShare', params: {slug: item.slug}})
      }


      return findAttributeOnSiteInfo('site_link') + routeData.href
    }
  },
  mounted() {
    this.getShares()
  }
}
</script>

<style scoped>

</style>